import React, { useState } from 'react';
import { useFetch, Items } from '@thinkwell/react.common'
import Enrollment from '../../models/Enrollment'

const EnrollmentsContext = React.createContext([{}, () => {}, {}, () => {}, () => {}, () => {}]);

const EnrollmentsProvider = (props) => {
  const enrollments = (props.value || []).map((s) => Enrollment(s))
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(enrollments))

  const [fetchEnrollmentsState, fetchEnrollments] = useFetch({onSuccess: setItems})

  const upsertEnrollment = (response) => {
    if (response.to && response.from) {
      upsertItem([
        Enrollment(response.to),
        Enrollment(response.from)
      ])
    } else if (response.to) {
      upsertItem(Enrollment(response.to), response.replace)
    } else {
      // add subscription from admin UI
      upsertItem(Enrollment(response))
    }
  }

  const value = [items, fetchEnrollments, fetchEnrollmentsState, upsertEnrollment, getItem, deleteItem]
  props.onValue && props.onValue(value)

  return (
    <EnrollmentsContext.Provider value={value}>
      {props.children}
    </EnrollmentsContext.Provider>
  );
};

export { EnrollmentsContext, EnrollmentsProvider}
